export const TAG_LABEL = { gps: "GPS", plate: "PLATE", phone: "PHONE", dl: "DL", dob: "DOB", name: "NAME", other: "TAG" };
export const TAG_CLS = {
  gps: "border-blue-500/50 text-blue-700 dark:text-blue-300 bg-blue-500/10",
  plate: "border-violet-500/50 text-violet-700 dark:text-violet-300 bg-violet-500/10",
  phone: "border-teal-500/50 text-teal-700 dark:text-teal-300 bg-teal-500/10",
  dl: "border-amber-500/50 text-amber-700 dark:text-amber-300 bg-amber-500/10",
  dob: "border-pink-500/50 text-pink-700 dark:text-pink-300 bg-pink-500/10",
  name: "border-emerald-500/50 text-emerald-700 dark:text-emerald-300 bg-emerald-500/10",
  other: "border-slate-500/50 text-slate-700 dark:text-slate-300 bg-slate-500/10",
};
